<template>
  <div class="safe-report body">
    <el-container>
      <!-- <SafeAside /> -->
      <el-main>
        <el-row type="flex" :gutter="10">
          <el-col :xl="16" :lg="16" :md="6" :sm="12">
            <div class="bg-White mt-2" style="margin-right: 300px">
              <div class="block p-3">
                <!-- <span class="demonstration">Default</span> -->
                <el-date-picker
                  @change="getTaslimReport"
                  v-model="dateRange"
                  type="daterange"
                  range-separator="الي"
                  format="yyyy/MM/dd"
                  value-format="yyyy-MM-dd"
                  start-placeholder="بداية الفترة"
                  end-placeholder="نهاية الفترة"
                >
                </el-date-picker>
              </div>
            </div>
          </el-col>
          <el-col style="margin-top: 15px" :xl="2" :lg="2" :md="6" :sm="12">
            <el-button
              class="mt-2"
              type="success"
              title="طباعه"
              icon="el-icon-printer"
              @click="sendToPrintAll(tableData)"
            ></el-button>
          </el-col>
        </el-row>
        <el-table
          class="mt-2"
          align="right"
          v-if="tableData.length > 0"
          :data="tableData"
          border
          style="width: 100%"
        >
          <el-table-column label="#" type="index" width="50"> </el-table-column>
          <el-table-column
            label="المُسلم"
            prop="from_user.name"
          ></el-table-column>
          <el-table-column
            label="المُستلم"
            prop="to_user.name"
          ></el-table-column>
          <el-table-column label="رصيد البداية" prop="start_amount">
            <template slot-scope="scope">
              {{ numberToFixed(scope.row.start_amount) }}
            </template>
          </el-table-column>
          <el-table-column label="رصيد النهاية" prop="end_amount">
            <template slot-scope="scope">
              {{ numberToFixed(scope.row.end_amount) }}
            </template>
          </el-table-column>
          <el-table-column sortable label="التوقيت" prop="updated_at">
            <template slot-scope="scope">
              {{ scope.row.updated_at | moment("Do / MM / YYYY | h:mm A") }}
            </template>
          </el-table-column>
        </el-table>
      </el-main>
    </el-container>
  </div>
</template>
<script>
// import SafeAside from "@/components/SafeAside.vue";
import axiosApi from "@/plugins/axios.js";
// import { ipcRenderer } from "electron";

export default {
  name: "CustomerReport",
  // components: { SafeAside },
  data() {
    return {
      false: false,
      true: true,
      dateRange: null,
      tableData: [],
    };
  },
  created() {},

  methods: {
    numberToFixed(number) {
      return Math.floor(number * 100) / 100;
    },
    getTaslimReport() {
      const loading = this.$loading({
        lock: true,
        text: "جاري تحميل البيانات",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      let url = `safe/taslim/1`;
      if (this.dateRange != null) {
        url += `/${this.dateRange[0]}`;
        url += `/${this.dateRange[1]}`;
      }

      axiosApi
        .get(url)
        .then((response) => {
          // console.log(response.data)
          this.tableData = response.data;
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          loading.close();
        });
    },
    sendToPrintAll(tableData) {
      // window.ipcRenderer = ipcRenderer;
      let data = {
        data: tableData,
        type: "TaslimReport",
        dateRange: this.dateRange,
        title: "تقرير التسليمات",
        img:
          "https://pos.staging.fatura-app.com" +
          JSON.parse(localStorage.getItem("branch")).logo,
      };
      console.log("🚀 ~ sendToPrintAll ~ data:", data)
      // ipcRenderer.send("printing", data);
    },
  },
};
</script>
<style scoped>
.el-table {
  width: 100%;
  max-height: 80%;
  overflow-y: scroll;
}
</style>
